import EDC from '../../../shared/globals';

/**
 *
 */
EDC.Animations.Number = function (scene, value) {
  this.scene = scene;
  this.value = value;
  this.step = 0;
  this.width = 0;
  this.height = 0;
  this.container = null;
  this.digits = [];
};
/**
 *
 */
EDC.Animations.Number.prototype.create = function () {
  const strValue = this.value.toString();

  for (let i = 0; i < strValue.length; i++) {
    const digit = this.scene.add.sprite(this.width, 0, `number-${strValue[i]}`).setOrigin(0);
    this.width += digit.width + (i < (strValue.length - 1) ? this.step : 0);
    if (this.height < digit.height) {
      this.height = digit.height;
    }
    this.digits.push(digit);
  }

  this.createContainer();

  for (let i = 0; i < this.digits.length; i++) {
    this.digits[i].x -= this.width / 2;
    this.digits[i].y -= this.digits[i].height / 2;
    this.container.add(this.digits[i]);
  }

  return this;
};
/**
 *
 */
EDC.Animations.Number.prototype.createContainer = function () {
  this.container = this.scene.add.container(0, 0);
};
/**
 *
 */
EDC.Animations.Number.prototype.place = function (x, y) {
  this.container.setPosition(x, y);
  return this;
};
/**
 *
 */
EDC.Animations.Number.prototype.appear = function (completeCallback) {
  this.container.setScale(0, 0);
  this.scene.tweens.add({
    targets: this.container,
    scaleX: 1,
    scaleY: 1,
    ease: 'Back.easeOut',
    duration: 600,
    onComplete() {
      if (completeCallback) {
        completeCallback();
      }
    },
  });
};
/**
 *
 */
EDC.Animations.Number.prototype.disappear = function () {
  this.scene.tweens.add({
    targets: this.container,
    alpha: 0,
    ease: 'Linear',
    duration: 600,
  });
};
/**
 *
 */
EDC.Animations.Number.prototype.destroy = function (x, y) {
  for (let i = 0; i < this.digits.length; i++) {
    this.digits[i].destroy();
    this.digits[i] = null;
  }
  this.container.destroy();
};
/**
 *
 */
EDC.Animations.Number.prototype.getWidth = function () {
  const bounds = this.container.getBounds();
  return bounds.width;
};

export default EDC.Animations.Number;
